import { render, staticRenderFns } from "./participationPersonnel.vue?vue&type=template&id=83a0af5e&scoped=true"
import script from "./participationPersonnel.vue?vue&type=script&lang=js"
export * from "./participationPersonnel.vue?vue&type=script&lang=js"
import style0 from "./participationPersonnel.vue?vue&type=style&index=0&id=83a0af5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a0af5e",
  null
  
)

export default component.exports